import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Eraser({
  color = 'icon.arrowBlue',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 20 18' {...props}>
      <Path
        d='M6.92188 5.91797L13.9891 12.9852'
        stroke={color}
        strokeWidth={strokeWidth}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.75252 17.1007H5.1523C4.43604 17.101 3.74901 16.8167 3.24238 16.3104L1.78608
        14.8541C0.737972 13.8008 0.737972 12.0985 1.78608 11.0451L11.1467 1.68452C12.2
        0.636409 13.9023 0.636409 14.9557 1.68452L18.2139 4.94273C19.262 5.9961 19.262
        7.69839 18.2139 8.75177L10.6534 16.3122C10.1487 16.8157 9.4654 17.0991 8.75252
        17.1007V17.1007Z'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Eraser.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
  fill: PropTypes.string,
}

export default Eraser
